/**
 * 가로스크롤 페이지네이션 — 현재 페이지를 가운데로 맞춘다
 *
 * 마크업은 resource/view/common/pagenate.blade.php, 스타일은
 * scss/cms/custom/pagination.scss 에 있다. 폰에서만 존재한다(d-md-none).
 *
 * 하는 일은 둘뿐이다.
 *   1) 화면이 그려질 때 현재 페이지가 스크롤 영역 한가운데 오도록 맞춘다
 *   2) 좌우 버튼으로 한 화면씩 밀어준다
 *
 * 나머지(먼 페이지로 이동)는 손가락 제스처가 알아서 한다.
 */
function centerActive(track) {
    const active = track.querySelector('.page-item.active');
    if (!active) return;

    // offsetLeft 는 위치 기준 조상이 무엇이냐에 따라 값이 달라진다.
    // 화면 좌표로 재면 그런 사정과 무관하게 항상 맞는다.
    const a = active.getBoundingClientRect();
    const t = track.getBoundingClientRect();

    track.scrollLeft += (a.left - t.left) - (t.width - a.width) / 2;
}

function initPaginationScroll(root) {
    (root || document).querySelectorAll('.pagination-scroll').forEach(function (box) {
        if (box.dataset.pagingInit) return;
        box.dataset.pagingInit = '1';

        const track = box.querySelector('.pagination-scroll-track');
        if (!track) return;

        centerActive(track);

        box.querySelectorAll('.pagination-scroll-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                const dir = Number(btn.dataset.scroll) || 1;
                track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
            });
        });
    });
}

// default.js 는 <head> 에서 읽히므로 이 시점에는 아직 목록이 없다
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPaginationScroll(); });
} else {
    initPaginationScroll();
}
